import { Column } from "./column";
import {
    boardBodyStyle,
    columnContainerStyle
} from "./jsw-interactive-board.styles";
import { useInteractiveBoardStore } from "./state";

export const BoardBody = () => {
    const [{ messages, todoCol, inProgressCol, doneCol }] =
        useInteractiveBoardStore();

    return (
        <div css={boardBodyStyle}>
            <div css={columnContainerStyle}>
                <Column title={messages.toDo} cards={todoCol} />
                <Column title={messages.inProgress} cards={inProgressCol} />
                <Column title={messages.done} cards={doneCol} />
            </div>
        </div>
    );
};
